import projection from '../generated/pwj219f1.json';
import { AcceptanceManifest } from '../types';

export const pwj219f1AcceptanceManifest = projection as AcceptanceManifest;
